import { combineReducers } from '@reduxjs/toolkit';

// Teacher Dashboard Reducers
import reducerUser from './user/reducer';
import reducerSignUp from './sign_up/reducer';
import reducerClasses from './classes/reducer';
import reducerStudents from './students/reducer';
import reducerStudent from './student/reducer';
import reducerGradingScales from './grading_scales/reducer';
import reducerAnswerSheets from './answer_sheets/reducer';
import reducerAssessments from './assessments/reducer';
import reducerGradings from './grading/reducer';

// UI State Reducers
import nightModeReducer from '../slices/nightModeSlice';
import themeReducer from '../slices/themeSlice';
import pwaReducer from '../slices/pwaSlice';

const rootReducer = combineReducers({
	// Teacher Dashboard
	user: reducerUser,
	sign_up: reducerSignUp,
	classes: reducerClasses,
	students: reducerStudents,
	student: reducerStudent,
	grading_scales: reducerGradingScales,
	answer_sheets: reducerAnswerSheets,
	assessments: reducerAssessments,
	gradings: reducerGradings,

	// UI State
	nightMode: nightModeReducer,
	theme: themeReducer,
	pwa: pwaReducer,
});

export { rootReducer };
